<!-- =========================================================================================
  File Name: TheNavbar.vue
  Description: Navbar component
  Component Name: TheNavbar
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div class="relative">
    <div class="vx-navbar-wrapper">
      <vs-navbar id="navbarGlobal" class="vx-navbar navbar-custom" :class="classObj">
        <div @click="showsideNav" :class="isSideBarBactive ? 'open' :' '" v-if="mobileResponsiveSideNav && windowWidth < 838" id="nav-icon3">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
        <!-- SM - OPEN SIDEBAR BUTTON -->
        <!-- <feather-icon class="sm:inline-flex xl:hidden cursor-pointer mr-1" icon="MenuIcon" @click.stop="showSidebar"></feather-icon> -->
        <img id="main-navbar-logo" height="30" src="../assets/dc-logo-white.svg" />
        <vs-button v-if="(($route.name == 'DocumentViewer' && $siteTypeId() ==1 && !($route.query.orig || $route.query.ref)) || $route.name == 'PodcastViewer' || $route.name == 'LiveStreamViewer' || $route.name == 'PresentationViewer')" @click="backToBrowse" icon-pack="feather" icon="icon-book" class="new-subject_btn__navbar ml-3">NEW SUBJECT</vs-button>
        <vs-button v-else-if="$route.name == 'FullLibrary' || $route.name == 'StudentAdditionalResources' || $route.name == 'Search' || $route.name == 'HomeworkViewer'" icon-pack="feather" icon="icon-arrow-left" class="back_btn__navbar ml-3" @click="backToBrowseContent">BACK</vs-button>
        <vs-button v-else-if="(($route.name == 'DocumentViewer' && ($route.query.orig || $route.query.ref == 'resources')) || $route.name == 'HLSVideoViewer' || $route.name == 'QuizTaskViewer') && !$route.query.mentoring" icon-pack="feather" icon="icon-arrow-left" class="back_btn__navbar ml-3" @click="backToResources"><span class="hidden sm:block">BACK</span></vs-button>
        <vs-button v-else-if="$route.name == 'Chat' && $acl.check('Teacher')" icon-pack="feather" icon="icon-arrow-left" class="back_btn__navbar ml-3" @click="backToTeacher"><span class="hidden sm:block">BACK</span></vs-button>
        <vs-button v-else-if="$route.name == 'Chat' && $acl.check('Student') && $route.query.mentoring" icon-pack="feather" icon="icon-arrow-left" class="back_btn__navbar ml-3" @click="backToMentoringMenu"><span class="hidden sm:block">BACK</span></vs-button>
        <vs-button v-else-if="($route.name == 'Chat' || $route.name == 'Mentoring') && $siteTypeId() != 1 && $acl.check('Student')" icon-pack="feather" icon="icon-arrow-left" class="back_btn__navbar ml-3" @click="backToMenu"><span class="hidden sm:block">BACK</span></vs-button>
        <vs-button v-else-if="$route.name == 'Chat' && $acl.check('Student')" icon-pack="feather" icon="icon-arrow-left" class="back_btn__navbar ml-3" @click="backToBrowse"><span class="hidden sm:block">BACK</span></vs-button>
        <vs-button v-else-if="$route.name == 'Chat' && $acl.check('Mentor')" icon-pack="feather" icon="icon-arrow-left" class="back_btn__navbar ml-3" @click="backToMentorDashboard"><span class="hidden sm:block">BACK</span></vs-button>
        <vs-button v-else-if="$route.name == 'StudentClassroomSelected'" icon-pack="feather" icon="icon-arrow-left" class="back_btn__navbar ml-3" @click="backToStudentClassrooms"><span class="hidden sm:block">BACK</span></vs-button>
        <vs-button v-else-if="$route.name == 'BackpackViewer' || ($route.name == 'LearningStyleBViewer' && $acl.check('Student'))" icon-pack="feather" icon="icon-arrow-left" class="back_btn__navbar ml-3" @click="backToMenu"><span class="hidden sm:block">BACK</span></vs-button>
        <vs-button v-else-if="$route.name == 'StudentClassroomAssessments'" icon-pack="feather" icon="icon-arrow-left" class="back_btn__navbar ml-3" @click="backToStudentClassroomSelected"><span class="hidden sm:block">BACK</span></vs-button>
        <vs-button v-else-if="$route.name == 'Q&A' || $route.name == 'CallBack' || $route.name == 'Media'" icon-pack="feather" icon="icon-arrow-left" class="back_btn__navbar ml-3" @click="backToMentoringMenu"><span class="hidden sm:block">BACK</span></vs-button>
        <vs-button v-else-if="$route.name == 'MultimediaVideoViewer' || ($route.name == 'DocumentViewer' && $route.query.mentoring)" icon-pack="feather" icon="icon-arrow-left" class="back_btn__navbar ml-3" @click="backToMedia"><span class="hidden sm:block">BACK</span></vs-button>
        <vs-button v-else-if="($route.name == 'VideoViewer' || $route.name == 'UploadViewer') && $siteTypeId() != 1" icon-pack="feather" icon="icon-arrow-left" class="back_btn__navbar ml-3" @click="backToLearningStyleB"><span class="hidden sm:block">BACK</span></vs-button>
        <vs-button v-else-if="$route.name == 'TimeCapture'" icon-pack="feather" icon="icon-arrow-left" class="back_btn__navbar ml-3" @click="$router.back()"><span class="hidden sm:block">BACK</span></vs-button>
        <vs-button v-else v-show="showBackButton" icon-pack="feather" icon="icon-arrow-left" class="back_btn__navbar ml-3" @click="backToTopic"><span class="hidden sm:block">BACK</span></vs-button>
        <vs-spacer></vs-spacer>
        
        <!-- <feather-icon icon="InfoIcon" class="cursor-pointer sm:mr-6" @click="showDeviceInfo"></feather-icon>
        <feather-icon icon="VideoIcon" class="cursor-pointer sm:mr-6" @click="testSnapshot"></feather-icon> -->

        <!-- NOTIFICATIONS -->
        <vs-dropdown v-if="$route.name != 'TimeCapture' && ($route.name != ('DocumentViewer' || 'VideoViewer') && ($siteTypeId() != 1 && $acl.check('Student') || $acl.check('Mentor')))" id="notificationDropdown" ref="notificationDropdown" vs-custom-content vs-trigger-click class="cursor-pointer notificationspace">
          <feather-icon icon="BellIcon" class="cursor-pointer sm:mr-6 feather__button" svgClasses="h-6 w-6" :badge="unreadNotifications.length"></feather-icon>
          <vs-dropdown-menu class="notification-dropdown dropdown-custom">
            <div class="cursor-pointer text-right bg-primary text-white" style="position: absolute; right: 20px; top: 27px; z-index: 99999;">
              <feather-icon @click="refresh" icon="RefreshCwIcon" class="cursor-pointer mb-2"></feather-icon>
            </div>
            <div class="notification-top text-center p-5 bg-primary text-white">
              <h3 class="text-white">{{ unreadNotifications.length }} New</h3>
              <p class="opacity-75">Notification(s)</p>
            </div>

            <VuePerfectScrollbar v-show="unreadNotifications.length > 0" ref="mainSidebarPs" class="vs-con-loading__container scroll-area--nofications-dropdown p-0 mb-10" :settings="settings" style="margin:0 !important">
              <ul class="bordered-items" :class="readNotifications.length == 0 ? ' ntfitems': ''">
                <li v-for="ntf in unreadNotifications" :key="ntf.id" class="flex justify-between px-4 py-4 notification cursor-pointer" >
                  <div v-if="ntf.notificationTitle != 'Profile Picture Reminder' && $siteTypeId() != 1">
                    <div class="flex items-start" @click="handleNtfClick(ntf)">
                      <!-- <feather-icon :icon="ntf.icon" :svgClasses="[`text-${ntf.category}`, 'stroke-current mr-1 h-6 w-6']"></feather-icon> -->
                      <div class="mx-2">
                        <span class="font-medium block notification-title" :class="[`text-${ntf.category}`]">{{ ntf.notificationTitle }}</span>
                        <!-- <span class="font-medium block notification-title" :class="[`text-${ntf.category}`]">{{ ntf.title }}</span> -->
                        <small v-html="ntf.notificationDescription"></small>
                      </div>
                    </div>
                    <small class="mt-1 whitespace-no-wrap">{{ elapsedTime(ntf.createdOn) }}</small>
                    <feather-icon id="readButton" @click.stop.prevent="ProgressComplete(ntf.id)" icon="XIcon" class="cursor-pointer disNoti"></feather-icon>
                  </div>
                </li>
              </ul>
            </VuePerfectScrollbar  >
            <div v-if="unreadNotifications.length > 0" @click="markAllAsRead" class="
              checkout-footer
              fixed
              pin-b
              rounded-b-lg
              text-primary
              w-full
              p-2
              font-semibold
              text-center
              border
              border-b-0
              border-l-0
              border-r-0
              border-solid
              border-grey-light
              cursor-pointer">
              <span>Mark All as Read</span>
            </div>
            <div v-show="readNotifications.length != 0 && unreadNotifications.length != 0" class="dividerntf"></div>
            <div style="text-align:center; padding-top: 0.5rem" v-show="readNotifications.length != 0" >In Progress</div>
            <VuePerfectScrollbar v-show="readNotifications.length > 0" ref="mainSidebarPs" class="vs-con-loading__container scroll-area--nofications-dropdown p-0 mb-10" :settings="settings">
              <ul class="bordered-items">
                <li v-for="ntf in readNotifications" :key="ntf.id" class="flex justify-between px-4 py-4 notification cursor-pointer">
                  <div class="flex items-start" @click="handleNtfClick(ntf)">
                    <!-- <feather-icon :icon="ntf.icon" :svgClasses="[`text-${ntf.category}`, 'stroke-current mr-1 h-6 w-6']"></feather-icon> -->
                    <div class="mx-2">
                      <span class="font-medium block notification-title" :class="[`text-${ntf.category}`]">{{ ntf.notificationTitle }}</span>
                      <!-- <span class="font-medium block notification-title" :class="[`text-${ntf.category}`]">{{ ntf.title }}</span> -->
                      <small v-html="ntf.notificationDescription"></small>
                    </div>
                  </div>
                  <small class="mt-1 whitespace-no-wrap">{{ elapsedTime(ntf.createdOn) }}</small>
                  <feather-icon id="readButton" @click.stop.prevent="ProgressComplete(ntf.id)" icon="XIcon" class="cursor-pointer disNoti"></feather-icon>
                </li>
              </ul>
            </VuePerfectScrollbar>
          </vs-dropdown-menu>
        </vs-dropdown>
        <!-- CHAT -->
        <vs-button v-if="($route.name == 'Menu' || $route.name == 'MentorDashboard' || !$route.name == 'Chat') && false" icon-pack="feather" icon="icon-message-circle" radius icon-after class="chat_btn__navbar mr-3" @click="goToChat"></vs-button>
        <a v-if="$getSiteId() != 21"> 
          <!-- HELP -->
          <vs-button id="help-btn-navbar" v-if="$route.name != ('DocumentViewer' || 'VideoViewer')" icon-pack="feather" icon="icon-help-circle" icon-after class="help_btn__navbar mr-3" @click="helpPopupActive = true"><span class="hidden sm:block">Help</span></vs-button>
        </a>
        <a v-if="$getSiteId() == 21">
          <!-- HOME -->
          <vs-button id="home-btn-navbar" icon-pack="feather" icon="icon-home" icon-after class="home_btn__navbar mr-3" @click="redirectToHome"><span class="hidden sm:block">Home</span></vs-button>
          </a> 
        <!-- USER META -->
        <div class="the-navbar__user-meta flex items-center">
          <div class="text-right leading-tight hidden sm:block">
            <p class="font-semibold">{{ user_displayName }}</p>
            <!-- <small>Available</small> -->
          </div>
          <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
            <div class="con-img ml-3">
              <img v-if="activeUserImg.startsWith('http')"
                key="onlineImg"
                :src="activeUserImg"
                alt="user-img"
                width="40"
                height="40"
                class="rounded-full shadow-md cursor-pointer block" />
              <img v-else
                key="localImg"
                src="https://forty5degreesstorage.blob.core.windows.net/user/avatar_default.png"
                alt="user-img"
                width="40"
                height="40"
                class="rounded-full shadow-md cursor-pointer block" />
            </div>
            <vs-dropdown-menu>
              <ul style="min-width: 9rem">
                <div v-if="checkRoleOfMentor()">
                  <li class="flex py-2 px-4 cursor-pointer hover:bg-school_primary hover:text-white" @click="moderatorToBackEnd">
                    <span class="mr-4">Go To Backend</span>
                    <feather-icon class="mb-1 ml-3" icon="UserIcon" svgClasses="w-4 h-4"></feather-icon>
                  </li>
                  <vs-divider class="my-1"></vs-divider>
                </div>
              
                <div v-if="!($route.name == 'AltProfile' || $route.name == 'StudentProfile' || $route.name == 'Profile') && $getSiteId() != 8">
                  <li class="flex py-2 px-4 cursor-pointer hover:bg-school_primary hover:text-white" @click="viewProfile">
                    <span class="mr-4">View Profile</span>
                    <feather-icon class="mb-1 ml-3" icon="UserIcon" svgClasses="w-4 h-4"></feather-icon>
                  </li>
                  <vs-divider class="my-1"></vs-divider>
                </div>
                <li class="flex py-2 px-4 cursor-pointer hover:bg-school_primary hover:text-white" @click="logout">
                  <span class="mr-4">Log Out</span>
                  <feather-icon class="mb-1 ml-3" icon="LogOutIcon" svgClasses="w-4 h-4"></feather-icon>
                </li>
              </ul>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>

        <vs-popup id="webcamPopup" title="Live Preview" :active.sync="webcamViewActive">
          <webcam-test v-if="webcamViewActive" />
        </vs-popup>

        <vs-popup id="deviceInfoPopup" title="Device Info" :active.sync="deviceInfoViewActive">
          <device-info v-if="deviceInfoViewActive" />
        </vs-popup>

        <vs-popup title="Having some problems?" :active.sync="helpPopupActive">
          <p class="pb-2">Please tell us about the issues you are experiencing:</p>
          <vs-textarea class="help-textarea" v-model="errorData.userMessage" />
          <p class="pb-2">Your WhatsApp number:</p>
          <vs-input autocomplete="off" v-validate="'digits:10'" name="WhatsApp number" v-model="errorData.whatsappNumber" />
          <span class="text-danger text-sm" v-show="errors.has('WhatsApp number')">{{ errors.first('WhatsApp number') }}</span>
          <div class="mt-3">
            <vs-button color="success" class="float-right" @click="submitIssue">Submit</vs-button>
          </div>
        </vs-popup>

        <vs-popup fullscreen title="Assessor Feedback Preview" id="AssessorFeedbackDocument" :active.sync="assessorfeedbackPopup">
          <div class="assessorFeedbackSize" style="width: fit-content; margin: auto;">
            <assessorFeedbackDocument v-if="assessorfeedbackPopup" :isStudent="true" :assessorFeedbackData="assessorFeedbackData" :taskResults="taskResults" :questionList="questionList" :assessorFeedback="assessorFeedback" @closeAssessorFeedbackDocument="closeAssessorFeedback" />
          </div>
        </vs-popup>
      </vs-navbar>
    </div>
  </div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import webcamTest from '../../layouts/components/WebcamTest';
import deviceInfo from '../../layouts/components/DeviceInfo.vue';
import assessorFeedbackDocument from "../../views/components/AssessorFeedbackDocument.vue";

export default {
  name: "the-navbar",
  components: {
    VuePerfectScrollbar,
    webcamTest,
    deviceInfo,
    assessorFeedbackDocument
  },
  data() {
    return {
      showCheck: false,
      webcamTest: false,
      deviceInfo: false,
      webcamViewActive: false,
      deviceInfoViewActive: false,
      signatureCheck:false,
      signatureRequired:false,
      unreadNotifications: [],
      readNotifications:[],
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.6
      },
      canChangeSite: false,
      taskDisplayId: "",
      coins: 0,
      showDisplayname: true,
      helpPopupActive: false,
        errorData: {
          taskId: null,
          userMessage: "",
          osName: "",
          osVersion: "",
          browserName: "",
          browserVersion: "",
          navigatorUserAgent: "",
          navigatorAppVersion: "",
          navigatorPlatform: "",
          navigatorVendor: "",
          isMobile: false,
          whatsappNumber: ""
        },
        assessorFeedbackData:{},
        assessorFeedbackDocument:false,
        assessorFeedback:{
          studentId:0,
          isCompetent:false,
          hasCompletedQuizzes:false,
          hasCompletedJournals:false,
          hasCompletedLogbook:false,
          hasCompletedPersonalInfo:false,
          hasCompletedAssessmentPrep:false,
          hasCompletedAssessmentPlan:false,
          hasCompletedDeclarationofAuth:false,
          logId:0,
          assessorFeedbackAnswers:[]
        },
        assessorFeedbackAnswer:{
          id:0,
          agree:null,
          answer:null
        },
        assessorFeedbackAnswers:[],
        questionList:[],
        popupHtml:``,
        freeTextPopup:``,
        lastIndex:0,
        assessorFeedbackPreviewPopup:false,
        taskResults:{},
        assessorfeedbackPopup:false,
        sideNavActive:false,
        windowWidth: window.innerWidth,
    };
  },
  props:{
    isSideBarBactive:{
      type:Boolean,
      required:false,
    }
  },
  computed: {
    // HELPER
    sidebarWidth() {
      return this.$store.state.sidebarWidth;
    },
    breakpoint() {
      return this.$store.state.breakpoint;
    },

    // NAVBAR STYLE
    classObj() {
      if (this.sidebarWidth == "default") return "navbar-default";
      else if (this.sidebarWidth == "reduced") return "navbar-reduced";
      else if (this.sidebarWidth) return "navbar-full";
    },

    // PROFILE
    user_displayName() {
      return JSON.parse(localStorage.getItem("userInfo")).displayName != null ? JSON.parse(localStorage.getItem("userInfo")).displayName.split('(')[0] : JSON.parse(localStorage.getItem("userInfo")).displayName;
    },
    activeUserImg() {
      return (
        JSON.parse(localStorage.getItem("userInfo")).photoURL || JSON.parse(localStorage.getItem("userInfo")).profilePictureUrl ||
        this.$store.state.AppActiveUser.img
      );
    },
    showBackButton: function() {
      var self = this;
      switch (self.$route.name) {
        case "DigiCourseBuilder":
          return true;
        case "DigiBackgrounds":
          return true;
        case "DigiMusic":
          return true;
        case "DigiScenes":
          return true;
        case "DigiNavigationMaps":
          return true;
        case "DigiCharacters":
          return true;
        case "DigiVideos":
          return true;
        case "DigiISpringQuizzes":
          return true;
        case "DigiISpringPresentations":
          return true;
        case "DigiDocuments":
          return true;
        case "DigiQuizzes":
          return true;
        case "StudentRoster":
          return true;
        case "StudentLibrary":
          return true;
        case "StudentClassrooms":
          return true;
        default:
          return false;
      }
    },
    mobileResponsiveSideNav:  function(){
      var self = this;
      switch (self.$route.name) {
        case "Dashboard":
          return true;
        case "ParentDashboard":
          return true;
        case "TeacherSubjects" :
          return true
        case "TeacherBrowseContent" :
          return true
        case "TeacherCalendar" :
          return  true
        case "TeacherLibrary" :  
          return  true 
        case "TeacherAssessments" :
          return true
        case "TeacherResources" :
          return true
        case "TeacherQA" :
          return true
        default:
          return false;
      }
    }
  },
  methods: {
    backToMedia() {
      var self = this;
      if (self.$route.query.orig == "media") {
        this.$router.push({ name: 'Media', query: { module: self.$route.query.module, n: self.$route.query.n } });
      }
      else if (self.$route.query.orig == "q&a") {
        this.$router.push({ name: 'Q&A', query: { module: self.$route.query.module, n: self.$route.query.n } });
      }
    },
    backToLearningStyleB(){
      this.$router.push({ name: "LearningStyleBViewer", params: { moduleId: localStorage.getItem('moduleId')}});
    },
    backToMentorDashboard() {
      this.$router.push({ name: 'MentorDashboard' });
    },
    backToMentoringMenu() {
      var self = this;
      if (self.$route.query.n) {
        self.$router.push({ name: 'Mentoring', query: { module: self.$route.query.module, n: self.$route.query.n } });
      }
      else {
        self.$router.push({ name: 'Mentoring', query: { module: self.$route.query.module } });
      }
    },
    backToTeacherResources() {
      this.$router.push({ name: 'TeacherResources' });
    },
    backToMenu() {
      this.$router.push({ name: 'Menu' });
    },
    backToBrowse() {
      var isTeacher = localStorage.getItem("isTeacher");
      isTeacher = isTeacher == "true" ? true : false;

      var isStudent = localStorage.getItem("isStudent");
      isStudent = isStudent == "true" ? true : false;

      if(isTeacher)        
        this.$router.push({ name: 'TeacherBrowseContent'});
      else if (isStudent)
        this.$router.push({ name: 'StudentRoster' });
      else
        this.$router.push({ name: 'BrowseContent'});
    },
    backToTeacher() {
      this.$router.push({ name: 'TeacherSubjects' });
    },
    backToStudentLibrary() {
      this.$router.push({ name: 'StudentLibrary' });
    },
    backToBrowseContent() {
      this.$router.push({ name: 'BrowseContent' });
    },
    backToResources() {
      if (this.$route.query.orig == 'lib') {
        this.$router.push({ name: 'FullLibrary' });
      }
      else if (this.$route.query.orig == 'mod' && localStorage.getItem("selectedData")) {
        var isStudent = localStorage.getItem("isStudent");
        isStudent = isStudent == "true" ? true : false;
        if (isStudent) {
          this.$router.push({ name: 'BrowseContent', params: { selectedData: JSON.parse(localStorage.getItem("selectedData")), navFromResourceView: true } });
        }
        else {
          this.$router.push({ name: 'TeacherBrowseContent', params: { selectedData: JSON.parse(localStorage.getItem("selectedData")), navFromResourceView: true } });
        }
      }
      else if (localStorage.getItem("selectedData")) {
        var isStudent = localStorage.getItem("isStudent");
        isStudent = isStudent == "true" ? true : false;
        if (isStudent) {
          this.$router.push({ name: 'BrowseContent', params: { selectedData: JSON.parse(localStorage.getItem("selectedData")), navFromLesson: true } });
        }
        else {
          this.$router.push({ name: 'TeacherBrowseContent', params: { selectedData: JSON.parse(localStorage.getItem("selectedData")), navFromLesson: true } });
        }
      } else if (this.$acl.check('Teacher')) {
        this.$router.push({ name: 'TeacherResources' });
      } else if (this.$route.query.ref == 'resources' && this.$acl.check('Student')) {
        this.$router.push({ name: 'StudentAdditionalResources' });
      }
    },
    backToStudentClassrooms() {
      this.$router.push({ name: 'StudentClassrooms' });
    },
    backToStudentClassroomSelected() {
      this.$router.push({ name: 'StudentClassroomSelected', query: this.$route.query });
    },
    goToChat() {
      if (this.$route.name == 'MentorDashboard') {
        this.$router.push({ name: "Chat", query: { mentoring: true } });
      }
      else {
        this.$router.push({ name: 'Chat' });
      }
    },
    viewProfile() {
      var self = this;
      if (self.$acl.check('Student')) {
        self.$router.push({ name: "DigiStudentProfile" });
      } else {
        var routeData = self.$router.resolve({ name: 'AltProfile' });
        window.open(routeData.href, '_self');
      }
    },
    redirectToHome() {
      var self = this;
      if(self.$acl.check('Principal')){
        self.$router.push({ url: "/principal/dashboard" });
        return
      }
      if (self.$acl.check('Student')) {
        if (self.$route.fullPath == "/digi/browsecontent") {
            
          self.$router.go({ name: "BrowseContent" });
        }
        else {
          self.$router.push({ name: "BrowseContent" });

        }
      }
      else {
        self.$router.push({name:"TeacherSubjects"});
      }
    },
    checkRoleOfMentor(){
      var self = this;
      if(self.$acl.check('SiteAdmin'))
        return true;
      if(self.$acl.check('Assessor'))
        return true;
      if(self.$acl.check('VideoEditor'))
        return true;
      if(self.$acl.check('Moderator'))
        return true;
      if(self.$acl.check('Evaluator'))
        return true;
      if(self.$acl.check('CourseBuilder'))
        return true;
    },
    moderatorToBackEnd(){
      window.location.replace("/dashboard");
    },
    signatureRequiredCheck(ntf){
      var self = this;
      if(ntf.relatedTableName == "AssessorFeedback"){
        self.markSingleAsInProgress(ntf.id);

        self.checkifFeedbackHasBeenSigned(ntf.key);
      
        return;
      }
      if (ntf.relatedTableName != "Task") {
        var onSuccess = response =>{
          self.signatureCheck = response.data.signature;
          self.signatureRequired = response.data.signatureRequired;

          self.markSingleAsInProgress(ntf.id);
          if(ntf.relatedTableName == "CourseTaskLog"){
            var routeData = null;
            if (self.$siteTypeId() == 1) {
              routeData = self.$router.resolve({ path: '/digi/viewassessment', query: { TaskLogId: ntf.key } });
            }
            else {
              routeData = self.$router.resolve({ path: '/viewassessment', query: { TaskLogId: ntf.key } });
            }
            window.open(routeData.href, '_blank');
          }
          else if(ntf.relatedTableName == "Module" && (!self.signatureRequired || (self.signatureRequired && self.signatureCheck ))){
            self.getModuleStartTask(ntf.key, function() {
              self.getCoins(ntf.userId, ntf.key, function() {
                localStorage.setItem("currentModule", ntf.key);
                self.getModuleRoute(ntf.key);
                //window.open(routeData.href, '_blank');
              })
            })
          }
          else if(ntf.relatedTableName == "StudentDocument"){
            self.getDocumentUrl(ntf.key);
          }
          else if (ntf.relatedTableName == "MentorSession") {
            self.getMentorSessionData(ntf.key);
          }
          else if(ntf.relatedTableName == "StudentDocumentLogbook"){
            var dropdownEl = document.getElementById("notificationDropdown");
            dropdownEl.click();
            self.$router.push({ name: 'DigiStudentProfile', query: { studentDocumentId: ntf.key } });
          }
        }
        self.$ajaxGet(self, `Student/GetSignature?moduleId=`+ self.moduleId,onSuccess);
      } else {
        self.getModuleIdByTask(ntf.key, () => {
          var signatureSuccess = result => {
            self.signatureCheck = result.data.signature;
            self.signatureRequired = result.data.signatureRequired;
            if (!self.signatureRequired || (self.signatureRequired && self.signatureCheck )) {
              var onSuccess = response => {
                if(response.data && response.data.moduleId && response.data.displayId && !response.data.styleB ){
                  self.getCoins(ntf.userId, response.data.moduleId, function() {
                    localStorage.setItem("currentModule", response.data.moduleId);
                    self.$router.push({ name: 'StoryViewer', params: { mode: "story", taskDisplayId: response.data.displayId, moduleId: response.data.moduleId, isStudent: "true", coins: self.coins } });
                  })
                }
                else{
                  var dropdownEl = document.getElementById("notificationDropdown");
                  dropdownEl.click();
                  self.$router.push({ name: 'LearningStyleBViewer', params: { moduleId:  response.data.moduleId } });
                }
              }
              self.$ajaxGet(self, `Student/GetTaskForStudentModule?taskId=${ntf.key}`,onSuccess);
            }
          }
          self.$ajaxGet(self, `Student/GetSignature?moduleId=` + self.moduleId, signatureSuccess);
        });
      }
    },
    handleNtfClick(ntf){
      var self = this;
      var routeData = "";
      self.moduleId = ntf.key;
      self.signatureRequiredCheck(ntf);
    },
    getModuleIdByTask(taskId, whenDone) {
      var self = this;

      var onSuccess = response => {
        self.moduleId = response.data;

        if (whenDone && typeof whenDone == "function")
          whenDone();
      }
      self.$ajaxGet(self, `Module/GetModuleId?taskId=${taskId}`,onSuccess);
    },
    getModuleRoute(){
      var self = this;

      var onSuccess = response =>{
        if(response.data){
          var dropdownEl = document.getElementById("notificationDropdown");
          dropdownEl.click();
          self.$router.push({ name: 'LearningStyleBViewer', params: { moduleId:  self.moduleId } });
        }
        else
          self.$router.push({ name: 'StoryViewer', params: { mode: "story", taskDisplayId: self.taskDisplayId, moduleId: self.moduleId, isStudent: "true", coins: self.coins } });
      }

      self.$ajaxGet(self, "Module/GetModuleLearningStyle?moduleId=" + self.moduleId ,onSuccess); 
    },
    getMentorSessionData(mentorSessionId) {
      var self = this;

      var onSuccess = function (response) {
        var dropdownEl = document.getElementById("notificationDropdown");
        dropdownEl.click();

        self.$router.push({ name: "Chat", query: { mentoring: true, module: response.data.moduleId }, params: { sessionData: response.data } });
      };

      self.$ajaxGet(self, "MentorModule/GetNotificationData?mentorSessionId=" + mentorSessionId, onSuccess);
    },
    getDocumentUrl(id) {
      var self = this;

      var onSuccess = function (response) {
        window.open(response.data, '_blank');
      };

      self.$ajaxGet(self, "Student/GetDocumentUrl/" + id, onSuccess);
    },
    showSidebar() {
      this.$store.commit("TOGGLE_IS_SIDEBAR_ACTIVE", true);
    },
    closeTab() {
      this.close();
    },
    close() {
      window.open("", "_self").close();
    },
    refresh() {
      var self = this;
      if(self.$refs.mainSidebarPs){
        this.showLoadingOnElement("mainSidebarPs", 0.75, "material");
      }
      this.getNotifications();
    },
    getModuleStartTask(moduleId, whenDone) {
      var self = this;

      var onSuccess = function (response) {
        self.taskDisplayId = response.data;
        if (whenDone && typeof whenDone == "function")
          whenDone();
      };

      self.$ajaxGet(self, "Module/GetModuleStartTask?moduleId=" + moduleId, onSuccess);
    },
    getCoins(studentId, moduleId, whenDone) {
      var self = this;

      var onSuccess = function (response) {
        self.coins = response.data;
        if (whenDone && typeof whenDone == "function")
          whenDone();
      };

      self.$ajaxGet(self, "CoinTransaction/GetCoins?studentId=" + studentId + "&moduleId=" + moduleId, onSuccess);
    },
    getNotifications() {
      var self = this;
      if (self.$siteTypeId() != 1 && self.$acl.check('Student') || self.$acl.check('Mentor')) {
        var onSuccess = response => {
          self.readNotifications = response.data.filter((read) => read.inProgress === true);
          self.unreadNotifications = response.data.filter((unread) => unread.inProgress === false);
        };
        
        var onFinally = response => {
          if (self.$refs.mainSidebarPs) {
            self.$vs.loading.close(self.$refs.mainSidebarPs.$el);
          }
        };
        self.$ajaxGet(self, "Notification/GetUnread", onSuccess, onFinally);
      }
    },
    markAllAsRead() {
      var self = this;
      self.showLoadingOnElement("mainSidebarPs", 0.75, "material");
      var data = {
        ids: self.unreadNotifications.map(function(item) { return item.id })
      };
      var onSuccess = response => {
        self.getNotifications();
      };
      self.$ajaxPost(self, "Notification/MarkAllAsRead", data, onSuccess);
    },
    markAsRead(ntfId){
      var self = this;
      var onSuccess = response =>{
        self.getNotifications();
      }
      self.$ajaxGet(self, "Notification/MarkSingleAsRead/" + ntfId, onSuccess);
    },
    ProgressComplete(ntfId) {
      var self = this;
      self.showLoadingOnElement("mainSidebarPs", 0.75, "material");
      var onSuccess = response => {
        this.markAsRead(ntfId)
      };
      self.$ajaxGet(self, "Notification/MarkInProgressComplete/" + ntfId, onSuccess);
    },
    markSingleAsInProgress(ntfId) {
      var self = this;
      self.showLoadingOnElement("mainSidebarPs", 0.75, "material");
      var onSuccess = response => {
        self.getNotifications();
      };
      self.$ajaxGet(self, "Notification/MarkInProgress/" + ntfId, onSuccess);
    },
    elapsedTime(startTime) {
      let x = new Date(startTime);
      let now = new Date();
      var timeDiff = now - x;
      timeDiff /= 1000;

      var seconds = Math.round(timeDiff);
      timeDiff = Math.floor(timeDiff / 60);

      var minutes = Math.round(timeDiff % 60);
      timeDiff = Math.floor(timeDiff / 60);

      var hours = Math.round(timeDiff % 24);
      timeDiff = Math.floor(timeDiff / 24);

      var days = Math.round(timeDiff % 365);
      timeDiff = Math.floor(timeDiff / 365);

      var years = timeDiff;

      if (years > 0) {
        return years + (years > 1 ? " Years " : " Year ") + "ago";
      } else if (days > 0) {
        return days + (days > 1 ? " Days " : " Day ") + "ago";
      } else if (hours > 0) {
        return hours + (hours > 1 ? " Hours " : " Hour ") + "ago";
      } else if (minutes > 0) {
        return minutes + (minutes > 1 ? " Mins " : " Min ") + "ago";
      } else if (seconds > 0) {
        return (seconds > 50 ? `${seconds} sec ago` : "Just Now");
      }

      return "Just Now";
    },
    testSnapshot() {
      this.webcamViewActive = true;
    },
    showDeviceInfo() {
      this.deviceInfoViewActive = true;
    },
    logout() {
      let routeData = null;

      this.$endUserSession();

      if (this.$getSiteId() == this.$getSiteIdWithContent() && window.location.href.toUpperCase().includes('DIGICAMPUS')) {
        routeData = this.$router.resolve({ path: '/home' });
        window.open(routeData.href, '_self');
        localStorage.clear();
        return;
      } else {
        routeData = this.$router.resolve({ path: '/login' });
      }
      
      localStorage.removeItem("userInfo");
      this.$acl.change("");
      localStorage.setItem("permissions", "");
      localStorage.setItem("userSiteInfo", "");
      localStorage.setItem("currentModule", "");
      localStorage.setItem("isStudent", "false");
      // delete lastKnownTopic from localStorage
      localStorage.removeItem("lastKnownTopic");
      window.open(routeData.href, '_self');

      // this.$vs.theme({ primary: "#7367F0" });
      // this.$vs.theme({ secondary: "#7367F0" });
    },
    changeSite() {
      localStorage.setItem("permissions", "");
      localStorage.setItem("userSiteInfo", "");
      this.$getSites(function() {
        this.$setPermissions(function() {
          this.$acl.change(localStorage.getItem("permissions").split(","));
          this.$router.push("/pages/selectSite");
        });
      });
    },
    getUserSites() {
      var self = this;
      var onSuccess = response => {
        self.canChangeSite = response.data.length == 1 ? false : true;
      };
      self.$ajaxGet(self, "Role/GetSites", onSuccess);
    },
    showLoadingOnElement(element, scale, type){
      var self = this;
      self.$vs.loading({
        type: type,
        container: self.$refs[element].$el,
        scale: scale
      });
    },
    backToTopic() {
      var isTeacher = localStorage.getItem("isTeacher");
      isTeacher = isTeacher == "true" ? true : false;

      var isStudent = localStorage.getItem("isStudent");
      isStudent = isStudent == "true" ? true : false;

      if (isTeacher) {
        this.$router.push({ name: 'TeacherBrowseContent', params: { selectedData: JSON.parse(localStorage.getItem('selectedData')), navFromBuilder: true } })
      }
      else if (isStudent) {
        this.$router.push({ name: 'BrowseContent' });
      }
      else {
        this.$router.push({ name: 'BrowseContent', params: { selectedData: JSON.parse(localStorage.getItem('selectedData')), navFromBuilder: true } });
      }
    },
    setDeviceType() {
      var self = this;

      var module = {
        options: [],
        header: [navigator.platform, navigator.userAgent, navigator.appVersion, navigator.vendor, window.opera],
        dataos: [
          { name: 'Windows Phone', value: 'Windows Phone', version: 'OS' },
          { name: 'Windows', value: 'Win', version: 'NT' },
          { name: 'iPhone', value: 'iPhone', version: 'OS' },
          { name: 'iPad', value: 'iPad', version: 'OS' },
          { name: 'Kindle', value: 'Silk', version: 'Silk' },
          { name: 'Android', value: 'Android', version: 'Android' },
          { name: 'PlayBook', value: 'PlayBook', version: 'OS' },
          { name: 'BlackBerry', value: 'BlackBerry', version: '/' },
          { name: 'Macintosh', value: 'Mac', version: 'OS X' },
          { name: 'Linux', value: 'Linux', version: 'rv' },
          { name: 'Palm', value: 'Palm', version: 'PalmOS' },
          { name: 'Huawei', value: 'Huawei', version: 'OS' }
        ],
        databrowser: [
          { name: 'Chrome', value: 'Chrome', version: 'Chrome' },
          { name: 'Firefox', value: 'Firefox', version: 'Firefox' },
          { name: 'Safari', value: 'Safari', version: 'Version' },
          { name: 'Internet Explorer', value: 'MSIE', version: 'MSIE' },
          { name: 'Opera', value: 'Opera', version: 'Opera' },
          { name: 'BlackBerry', value: 'CLDC', version: 'CLDC' },
          { name: 'Mozilla', value: 'Mozilla', version: 'Mozilla' },
          { name: 'Huawei Browser', value: 'Huawei Browser', version: 'Huawei' }
        ],
        init: function () {
          var agent = this.header.join(' '),
            os = this.matchItem(agent, this.dataos),
            browser = this.matchItem(agent, this.databrowser);

          return { os: os, browser: browser };
        },
        matchItem: function (string, data) {
          var i = 0,
            j = 0,
            html = '',
            regex,
            regexv,
            match,
            matches,
            version;

          for (i = 0; i < data.length; i += 1) {
            regex = new RegExp(data[i].value, 'i');
            match = regex.test(string);
            if (match) {
              regexv = new RegExp(data[i].version + '[- /:;]([\\d._]+)', 'i');
              matches = string.match(regexv);
              version = '';
              if (matches) { if (matches[1]) { matches = matches[1]; } }
              if (matches) {
                matches = matches.split(/[._]+/);
                for (j = 0; j < matches.length; j += 1) {
                  if (j === 0) {
                    version += matches[j] + '.';
                  } else {
                    version += matches[j];
                  }
                }
              } else {
                version = '0';
              }
              return {
                name: data[i].name,
                version: parseFloat(version)
              };
            }
          }
          return { name: 'unknown', version: 0 };
        }
      };

      var e = module.init();

      self.errorData.osName = e.os.name;
      self.errorData.osVersion = e.os.version;
      self.errorData.browserName = e.browser.name;
      self.errorData.browserVersion = e.browser.version;
      self.errorData.navigatorUserAgent = navigator.userAgent;
      self.errorData.navigatorAppVersion = navigator.appVersion;
      self.errorData.navigatorPlatform = navigator.platform;
      self.errorData.navigatorVendor = navigator.vendor;
    },
    submitIssue() {
      var self = this;
      self.helpPopupActive = false;
      self.errorData.taskId = localStorage.getItem("tid") ? parseInt(localStorage.getItem("tid")) : null;
      self.errorData.isMobile = self.isMobile();
      
      var onSuccess = response => {
        self.$vs.notify({
          title:'Information',
          color: "success",
          text: "Issue submitted!",
          position:'top-right',
          iconPack: 'feather',
          icon:'icon-check'
        });
      };

      self.$ajaxPost(self, "Student/LogError", self.errorData, onSuccess);
    },
    assessorfeedbackDocumentOpen(key){
      var self = this;

      var onSuccess = response =>{
        this.assessorFeedbackData = response.data;
        this.taskResults.fullname = response.data.learnerFullName;
        this.questionList = response.data.assessorFeedbackQuestionDTO;
        this.assessorFeedback = response.data.assessorFeedbackDTO;
        // var dropdownEl = document.getElementById("notificationDropdown");
        // dropdownEl.click();
        this.assessorfeedbackPopup = true;
      }
    
      self.$ajaxGet(self, `AssessorFeedback/GetDetails/${key}` , onSuccess);
    },
      htmlBuilderForassessorFeedbackDocumentQuestions(){
      var self = this;
      var onSuccess = response =>{
        self.questionList = response.data;
        self.popupHtml = "";
        self.freeTextPopup = "";
        for (let index = 0; index < self.questionList.length -2; index++) {
          self.popupHtml += `<div class="pretty p-default p-round p-fill float-left mb-3">
                  <input type="checkbox" class="check_container" id="Feedback${self.questionList[index].id}" name="${self.questionList[index].question}">
                  <div class="state p-success">
                    <label for="Feedback${self.questionList[index].id}">${self.questionList[index].question}</label><br>
                  </div>
                </div>`;
          self.lastIndex = index;
        }
        for (let index = self.lastIndex+1; index < self.questionList.length ; index++) {
          self.freeTextPopup +=
          ` <div class=" mb-3">
              <div class="vs-component vs-con-textarea vs-textarea-primary" style="border: 1px solid rgba(0, 0, 0, 0.08);">
                  <label for="Feedback${self.questionList[index].id}">${self.questionList[index].question}</label><br>
                  <textarea id="Feedback${self.questionList[index].id}"  class="vs-textarea"></textarea> 
              </div>
            </div>`;
          
        }

        self.displayAssessmentQuestions();
      }

      self.$ajaxGet(self, "assessor/FeedbackDocumentQuestions" , onSuccess);
    },
    displayAssessmentQuestions(){
      var self = this;
      
      self.$swal({
        title: 'Feedback',
        icon: 'info',
        html: `
        <h2 style="color: #3fc3ee">Please complete the following: </h2>
        <h4>Click on the checkbox to AGREE with the below statements.<br></h4> 
        <h4>Leave the checkbox if you disagree with the statements.</h4><br>
        <div class="popupCustomContent mb-3">
          ${self.popupHtml}
        </div>`,
        customClass: {
          confirmButton: 'vs-component vs-button vs-button-primary vs-button-filled mr-4',
        },
        showClass: {
          popup: 'animate__animated animate__bounceIn assessment-Questions',
        },
        confirmButtonText:'Next',
        showCancelButton: true,
        buttonsStyling: false,
        allowOutsideClick:false,
        allowEnterKey:false,
        allowEscapeKey:false,
        showCancelButton:false,
        preConfirm:(data) =>{
          for (let index = 1; index < self.questionList.length -1; index++) {
            var generatedId = `Feedback${self.questionList[index-1].id}`
            var quizFeedback = document.getElementById(generatedId).checked;
            var thisAssessorFeedbackAnswer = {
              id:index,
              agree:quizFeedback,
              answer:null
            }
            this.assessorFeedback.assessorFeedbackAnswers.push(thisAssessorFeedbackAnswer);
          }
        },
      }).then((result) => {
        self.freeTextShowPopup();
      });
    },
    freeTextShowPopup(){
      var self = this;
      self.$swal({
        title: 'Feedback',
        icon: 'info',
        html: `
        <h4>Complete the following</h4>
        <div class="popupCustomContent mb-3">
          ${self.freeTextPopup}
        </div>`,
        customClass: {
          confirmButton: 'vs-component vs-button vs-button-primary vs-button-filled mr-4',
        },
        showClass: {
          popup: 'animate__animated animate__bounceIn assessment-Questions',
        },
        confirmButtonText:'Complete',
        showCancelButton: true,
        buttonsStyling: false,
        allowOutsideClick:false,
        allowEnterKey:false,
        allowEscapeKey:false,
        showCancelButton:false,
        preConfirm:(data) =>{
          for (let index = self.lastIndex +1; index < self.questionList.length; index++) {
            var generatedId = `Feedback${self.questionList[index].id}`
            var quizFeedback = document.getElementById(generatedId).value;
            var thisAssessorFeedbackAnswer = {
              id:index +1,
              agree:null,
              answer:quizFeedback
            }
            this.assessorFeedback.assessorFeedbackAnswers.push(thisAssessorFeedbackAnswer);
          }
        },
      }).then((result) => {
        self.addStudentFeedback();
      });
    },
    addStudentFeedback(){
      var self = this;

      var onSuccess = response =>{
        self.assessorFeedbackData = response.data;
        self.assessorfeedbackDocumentOpen(self.moduleId);
      }
      var onFinally = response =>{
        if (self.$refs.whole_page) {
          self.$vs.loading.close(self.$refs.whole_page.$el);
        }
      }
      self.assessorFeedback.Id = self.moduleId;
      self.$ajaxPost(self, `assessor/FeedbackDocumentStudent/${self.moduleId}` , self.assessorFeedback.assessorFeedbackAnswers , onSuccess, onFinally);
    },
    closeAssessorFeedback(){
      var self = this;
      self.assessorfeedbackPopup = false;
      self.refresh();
    },
    checkifFeedbackHasBeenSigned(key){
      var self = this;
      var onSuccess = response =>{
        if(!response.data){
          self.htmlBuilderForassessorFeedbackDocumentQuestions();
        }
        else{
          self.refresh();
        }
      }
      self.$ajaxGet(self, `assessorfeedback/signedByStudent/${key}` , onSuccess);
    },
    showsideNav(){
      this.$emit("toggleSideBar");
    },
    onResize(){
      this.windowWidth = window.innerWidth;
    }
  },
  directives: {},
  mounted() {
    var self = this;
    setTimeout(() => {
      this.showsideNav();
    }, 1250);
    self.getNotifications();
    self.setDeviceType();

    self.isTeacher = localStorage.getItem("isTeacher");
    self.isTeacher = self.isTeacher == "true" ? true : false;

    var isStudentLocal = localStorage.getItem("isStudent");
    isStudentLocal = isStudentLocal == "true" ? true : false;

    if(localStorage.getItem('type') == 'digi')
      self.showDisplayname = false;

    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
    })
  }
};
</script>
<style lang="scss">
  
  .feather__button{
    background-color: rgba(255, 255, 255, 0.2);
    padding: 6px;
    border-radius: 50%;
  }

  #deviceInfoPopup div.vs-popup {
    width: 1100px;
  }

  #webcamPopup div.vs-popup {
    width: 715px;
  }

  #notificationDropdown span.feather-icon span.feather-icon-badge {
    background-color: rgba(var(--vs-danger), 1) !important;
  }

  #unReadButton svg.feather.feather.feather-circle {
    position: absolute;
  }

  #readButton svg.feather.feather.feather-check-circle {
    position: absolute;
  }

  #readButton svg.feather.feather.feather-check-circle {
    color: rgb(0, 255, 0);
  }

  #content-area {
    margin-left: 0px;
  }

  .main-menu-sidebar .vs-sidebar.vs-sidebar-reduce {
    max-width: 80px !important;
  }

  .vs-sidebar.vs-sidebar-reduce:hover:not(.vs-sidebar-reduceNotHoverExpand) {
    max-width: 80px !important;
  }

  .back_btn__navbar {
    border-radius: 45px;
    font-size: 16px !important;
    padding: .75rem 1rem !important;

    .vs-icon {
      font-size: 1.4rem !important;
    }

    @media screen and (max-width: 575px) {
      i {
        margin-right: 0px !important;
      }
    }

    @media screen and (min-width: 576px) {
      i {
        margin-right: 11px !important;
      }
    }
  }

  .help_btn__navbar {
    border-radius: 45px;
    font-size: 16px !important;
    padding: .75rem 1rem !important;
    
    .vs-icon {
      font-size: 1.4rem !important;
    }

    @media screen and (max-width: 575px) {
      i {
        margin-left: 0px !important;
      }
      
    }

    @media screen and (min-width: 576px) {
      i {
        margin-left: 5px !important;
      }
    }
  }
  .home_btn__navbar {
    border-radius: 45px;
    font-size: 16px !important;
    padding: .75rem 1rem !important;
    
    .vs-icon {
      font-size: 1.4rem !important;
    }

    @media screen and (max-width: 575px) {
      i {
        margin-left: 0px !important;
      }
      
    }

    @media screen and (min-width: 576px) {
      i {
        margin-left: 5px !important;
      }
    }
  }

  .backpack_btn__navbar {
    border-radius: 45px;
    font-size: 16px !important;
    padding: .75rem 1rem !important;

    .vs-icon {
      font-size: 1.4rem !important;
    }
  }

  .disNoti{
    top: 0;
    left: 0;
  }  
  .dividerntf{
    border: .5px solid white;
    margin-bottom: 5px;
  }
  
  .ntfitems{
    li:last-child{
      padding-bottom: 3.5rem !important;
    }
  }

  @media screen and (max-width: 575px) {
    .notificationspace{
      margin-right: 10px;
    }
    .help_btn__navbar{
      margin: 0 !important;
    }
    .home_btn__navbar{
      margin: 0 !important;
    }
  }

.AssessorPopUp{
  margin: auto;
  width: fit-content;
  .Review-Dimensions-free{
    width: 100%;
  }
}
.assessment-Questions{
  width: fit-content !important;
  .popupCustomContent{
    width: fit-content;
    height: fit-content;
    display: flex;
    flex-direction: column;
    text-align: left;
  }
}

#nav-icon1, #nav-icon2, #nav-icon3, #nav-icon4 {
  width: 60px;
  height: 45px;
  position: relative;
  -webkit-transform: rotate(0deg);
  -moz-transform: rotate(0deg);
  -o-transform: rotate(0deg);
  transform: rotate(0deg);
  -webkit-transition: .5s ease-in-out;
  -moz-transition: .5s ease-in-out;
  -o-transition: .5s ease-in-out;
  transition: .5s ease-in-out;
  cursor: pointer;
  transform: scale(0.5);
}

#nav-icon1 span, #nav-icon3 span, #nav-icon4 span {
  display: block;
  position: absolute;
  height: 9px;
  width: 100%;
  background: #fff;
  border-radius: 9px;
  opacity: 1;
  left: 0;
  -webkit-transform: rotate(0deg);
  -moz-transform: rotate(0deg);
  -o-transform: rotate(0deg);
  transform: rotate(0deg);
  -webkit-transition: .25s ease-in-out;
  -moz-transition: .25s ease-in-out;
  -o-transition: .25s ease-in-out;
  transition: .25s ease-in-out;
}

/* Icon 2 */

/* Icon 3 */

#nav-icon3 span:nth-child(1) {
  top: 0px;
}

#nav-icon3 span:nth-child(2),#nav-icon3 span:nth-child(3) {
  top: 18px;
}

#nav-icon3 span:nth-child(4) {
  top: 36px;
}

#nav-icon3.open span:nth-child(1) {
  top: 18px;
  width: 0%;
  left: 50%;
}

#nav-icon3.open span:nth-child(2) {
  -webkit-transform: rotate(45deg);
  -moz-transform: rotate(45deg);
  -o-transform: rotate(45deg);
  transform: rotate(45deg);
}

#nav-icon3.open span:nth-child(3) {
  -webkit-transform: rotate(-45deg);
  -moz-transform: rotate(-45deg);
  -o-transform: rotate(-45deg);
  transform: rotate(-45deg);
}

#nav-icon3.open span:nth-child(4) {
  top: 18px;
  width: 0%;
  left: 50%;
}
</style>

